<rms-mod [flippable]="true" transitionMode="morph"
         [flipped]="!!SelectedCustomer"
         collapsedWidth="100%"
         expandedWidth="100%"
         height="calc(100vh - 100px)"
         [includeHeader]="false"
         [backButton]="!!SelectedCustomer"
         (backButtonClicked)="clearSelection()">
  <div mod-front class="crm-search-screen">
    <div class="crm-search-toolbar"><div><h1>Roaster CRM</h1><p>Customer relationships, orders, reserves and insights in one place.</p></div><div class="crm-search-controls"><rms-input label="Search customers" placeholder="Name, contact, email, phone, city, trader, or ID" [(ngModel)]="SearchTerm" (ngModelChange)="searchChanged()"></rms-input><rms-checkbox label="Include inactive" [(ngModel)]="IncludeInactive" (ngModelChange)="loadCustomers()"></rms-checkbox></div></div>
    @if(Loading){<p class="loading-message" role="status">Loading customers…</p>}
    <div class="search-results">
      <rms-table [data]="SearchResults" [columns]="SearchColumns" [HeaderButtons]="Buttons" [clickableRow]="true" (onRowClick)="selectCustomer($event)"></rms-table>
    </div>

    <div class="stat-cards">
      <div class="stat-card stat-active">
        <div class="stat-value">{{StatActiveCustomers}}</div>
        <div class="stat-label">Active Customers</div>
      </div>

      <div class="stat-card stat-pastdue">
        <div class="stat-value">{{StatPastDue}}</div>
        <div class="stat-label">Past Due</div>
      </div>
      <div class="stat-card stat-samples">
        <div class="stat-value">{{StatSampleFollowUps}}</div>
        <div class="stat-label">Sample Follow-ups</div>
      </div>
    </div>
  </div>

  <div mod-back class="crm-detail-screen">
    @if(SelectedCustomer){
    <div class="customer-header">
      <div class="customer-avatar">{{(CustomerDetails?.CompanyName || SelectedCustomer.CompanyName || '?').trim().charAt(0)}}</div>
      <div class="customer-header-text">
        <div class="customer-header-top">
          <h1>{{CustomerDetails?.CompanyName || SelectedCustomer.CompanyName}}</h1>
          <span class="status-badge" [class.inactive]="CustomerDetails?.Inactive">
            {{CustomerDetails?.Inactive ? 'Inactive' : 'Active'}}
          </span>
        </div>
        <div class="customer-header-meta">
          <span>Customer {{SelectedCustomer.CompanyID}}</span>
          <span>Owner Group: {{CustomerDetails?.OwnerGroupName || '—'}}</span>
          <span>Trader: {{CustomerDetails?.TraderName || '—'}}</span>
        </div>
      </div>
      <div class="customer-status-toggle">
        <rms-checkbox label="Active" [(ngModel)]="CustomerActive" [disabled]="!CanEdit || !CustomerDetails" (ngModelChange)="toggleCustomerStatus($event)"></rms-checkbox>
      </div>
    </div>

    @if(DetailsLoading){<p class="loading-message" role="status">Loading customer details…</p>}
    <rms-tab-group>
      <rms-tab label="Overview">
        <ng-template>
          @if(CustomerDetails){
          <div class="overview-layout">
            <fieldset class="rms-fieldset overview-fields">
              <legend>Customer Overview</legend>
              <button mat-icon-button class="corner-edit-icon" [disabled]="!CanEdit" aria-label="Edit customer overview" (click)="editOverview()"><mat-icon>edit</mat-icon></button>
              <div class="overview-grid">
                <div class="field"><label>Legal Name</label><div>{{CustomerDetails.LegalName || '—'}}</div></div><div class="field"><label>Corporate Name</label><div>{{CustomerDetails.CorporateName || '—'}}</div></div><div class="field"><label>Marketing Name</label><div>{{CustomerDetails.MarketingName || '—'}}</div></div><div class="field"><label>AR Balance</label><div>{{OverviewARBalance != null ? (OverviewARBalance | currency) : '—'}}</div></div><div class="field"><label>Past Due</label><div>{{OverviewPastDue != null ? (OverviewPastDue | currency) : '—'}}</div></div>
                <div class="field"><label>DBA</label><div>{{CustomerDetails.CompanyName || '—'}}</div></div>
                <div class="field"><label>Payment Preference</label><div>{{OverviewPaymentMethodName}}</div></div>
                <div class="field"><label>Payment Terms</label><div>{{OverviewPaymentTermName}}</div></div>
                <div class="field"><label>Last Trucker Used</label><div>{{CustomerDetails.LastTruckerUsed || '—'}}</div></div>
                <div class="field"><label>Last Pickup</label><div>{{CustomerDetails.LastPickupDate ? (CustomerDetails.LastPickupDate | date:'shortDate':'UTC') : '—'}}</div></div><div class="field"><label>Last Warehouse</label><div>{{CustomerDetails.LastWarehouse || '—'}}</div></div><div class="field"><label>Last PRO Number</label><div>{{CustomerDetails.LastProNumber || '—'}}</div></div><div class="field"><label>Load-out Reference</label><div>{{CustomerDetails.LoadOut || '—'}}</div></div>
                <div class="field"><label>Credit Limit</label><div>{{CustomerDetails.CreditLimit != null ? (CustomerDetails.CreditLimit | currency) : '—'}}</div></div>
                <div class="field"><label>OCIA Member Number</label><div>{{CustomerDetails.OciaMemberNumber || '—'}}</div></div>
                <div class="field"><label>Non-Domestic</label><div>{{CustomerDetails.NonDomestic ? 'Yes' : 'No'}}</div></div>
              </div>
            </fieldset>

            <fieldset class="rms-fieldset overview-billing">
              <legend>Customer Billing Information</legend>
              <button mat-icon-button class="corner-edit-icon" [disabled]="!CanEdit" aria-label="Edit billing address" (click)="editDefaultBillingAddress()"><mat-icon>edit</mat-icon></button>
              <div class="overview-grid">
                <div class="field"><label>Address Name</label><div>{{CustomerDetails.DefaultBillingAddressName || '—'}}</div></div>
                <div class="field"><label>Street</label><div>{{CustomerDetails.DefaultBillingStreet || '—'}}</div></div>
                <div class="field"><label>City</label><div>{{CustomerDetails.DefaultBillingCity || '—'}}</div></div>
                <div class="field"><label>State</label><div>{{CustomerDetails.DefaultBillingState || '—'}}</div></div>
                <div class="field"><label>Zip</label><div>{{CustomerDetails.DefaultBillingZip || '—'}}</div></div>
              </div>
              @if(!CustomerDetails.DefaultBillingStreet){
              <p class="billing-note">No default billing address is set. Add or select one on the Addresses tab.</p>
              }
            </fieldset>

            @if(RelatedCustomers.length){<fieldset class="rms-fieldset overview-related"><legend>Related Customers</legend><p>Customers in the same owner group</p><div class="inline-actions">@for(customer of RelatedCustomers; track customer.CompanyID){<button mat-button (click)="selectCustomer({row: customer})">{{customer.CompanyName}} @if(customer.Inactive){<span class="status-badge inactive">Inactive</span>}</button>}</div></fieldset>}
            <fieldset class="rms-fieldset overview-actions">
              <legend>Actions</legend>
              <div class="inline-actions">
                <button mat-button class="btn-bg-blue" [disabled]="!CanEdit || CustomerDetails.Inactive" (click)="createOrder()">Create Order</button>
                <button mat-button class="btn-bg-blue" [disabled]="!CanEdit" (click)="quickRequestSample()">Request Sample</button>
                <button mat-button class="btn-bg-green" [disabled]="!CanEdit" (click)="quickAddNote()">Add Note</button>
              </div>
            </fieldset>
          </div>
          }
        </ng-template>
      </rms-tab>
      <rms-tab label="Contacts">
        <ng-template>
          <app-customer-contacts [companyId]="SelectedCustomer.CompanyID" [canEdit]="CanEdit"></app-customer-contacts>
        </ng-template>
      </rms-tab>
      <rms-tab label="Billing & Shipping">
        <ng-template>
          <app-customer-addresses [companyId]="SelectedCustomer.CompanyID" [canEdit]="CanEdit"></app-customer-addresses>
        </ng-template>
      </rms-tab>
      <rms-tab label="Payment & Terms">
        <ng-template>
          <app-customer-payment-preferences [companyId]="SelectedCustomer.CompanyID" [canEdit]="CanEdit"></app-customer-payment-preferences>
        </ng-template>
      </rms-tab>
      <rms-tab label="Orders">
        <ng-template>
          <app-customer-orders [companyId]="SelectedCustomer.CompanyID"></app-customer-orders>
        </ng-template>
      </rms-tab>
      <rms-tab label="Reserves"><ng-template><app-customer-reserves [companyId]="SelectedCustomer.CompanyID"></app-customer-reserves></ng-template></rms-tab>
      <rms-tab label="Insights"><ng-template><section class="crm-insights"><mat-icon>bar_chart</mat-icon><h2>Sales &amp; customer insights</h2><p>A dedicated space for your Power BI sales reports and customer dashboards.</p><div class="insight-tiles"><article><h3>Sales performance</h3><p>Customer sales, trends and coffee mix</p></article><article><h3>Customer activity</h3><p>Ordering patterns and account insights</p></article></div><p class="insight-note">Power BI connection not configured yet. Reports will appear here once the report and access settings are connected.</p></section></ng-template></rms-tab>
      <rms-tab label="Payments">
        <ng-template>
          <app-customer-payments-tab [companyId]="SelectedCustomer.CompanyID" [canEdit]="CanEdit" [companyName]="CustomerDetails?.CompanyName || SelectedCustomer.CompanyName"></app-customer-payments-tab>
        </ng-template>
      </rms-tab>
      <rms-tab label="Notes">
        <ng-template>
          <app-customer-notes [companyId]="SelectedCustomer.CompanyID" [canEdit]="CanEdit"></app-customer-notes>
        </ng-template>
      </rms-tab>
      <rms-tab label="Samples">
        <ng-template>
          <app-customer-samples [companyId]="SelectedCustomer.CompanyID" [canEdit]="CanEdit"></app-customer-samples>
        </ng-template>
      </rms-tab>
      <rms-tab label="Audit">
        <ng-template>
          <app-customer-audit [companyId]="SelectedCustomer.CompanyID"></app-customer-audit>
        </ng-template>
      </rms-tab>
    </rms-tab-group>
    }
  </div>
</rms-mod>
